// src/components/ui/SectionHeader.jsx

import React from 'react';
import { PAGE } from './pageTheme';

export default function SectionHeader({ title, subtitle, style }) {
  return (
    <div style={style}>
      <h2 style={PAGE.type.sectionTitle}>{title}</h2>
      {subtitle && <p style={PAGE.type.sectionSubtitle}>{subtitle}</p>}
    </div>
  );
}
